export default __webpack_public_path__ + "static/media/ALLERGEN_FISH.cc3f0944.png";